// European countries and their main cities — used by the service filters.
export const EUROPE = {
  Austria: ["Vienna", "Graz", "Linz", "Salzburg", "Innsbruck", "Klagenfurt"],
  Belgium: ["Brussels", "Antwerp", "Ghent", "Charleroi", "Liège", "Bruges", "Leuven"],
  Bulgaria: ["Sofia", "Plovdiv", "Varna", "Burgas", "Ruse"],
  Croatia: ["Zagreb", "Split", "Rijeka", "Osijek", "Zadar", "Dubrovnik"],
  Cyprus: ["Nicosia", "Limassol", "Larnaca", "Paphos"],
  "Czech Republic": ["Prague", "Brno", "Ostrava", "Plzeň", "Olomouc", "Liberec"],
  Denmark: ["Copenhagen", "Aarhus", "Odense", "Aalborg", "Esbjerg"],
  Estonia: ["Tallinn", "Tartu", "Narva", "Pärnu"],
  Finland: ["Helsinki", "Espoo", "Tampere", "Vantaa", "Turku", "Oulu"],
  France: ["Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Bordeaux", "Lille", "Strasbourg", "Montpellier"],
  Germany: ["Berlin", "Hamburg", "Munich", "Cologne", "Frankfurt", "Stuttgart", "Düsseldorf", "Leipzig", "Dortmund", "Bremen"],
  Greece: ["Athens", "Thessaloniki", "Patras", "Heraklion", "Larissa", "Rhodes"],
  Hungary: ["Budapest", "Debrecen", "Szeged", "Miskolc", "Győr", "Pécs"],
  Iceland: ["Reykjavík", "Akureyri", "Hafnarfjörður"],
  Ireland: ["Dublin", "Cork", "Limerick", "Galway", "Waterford"],
  Italy: ["Rome", "Milan", "Naples", "Turin", "Palermo", "Genoa", "Bologna", "Florence", "Bari", "Catania", "Verona", "Venice"],
  Latvia: ["Riga", "Daugavpils", "Liepāja", "Jelgava"],
  Lithuania: ["Vilnius", "Kaunas", "Klaipėda", "Šiauliai", "Panevėžys"],
  Luxembourg: ["Luxembourg City", "Esch-sur-Alzette", "Differdange"],
  Malta: ["Valletta", "Birkirkara", "Sliema", "St. Julian's"],
  Netherlands: ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven", "Groningen", "Tilburg", "Almere", "Breda", "Nijmegen"],
  Norway: ["Oslo", "Bergen", "Trondheim", "Stavanger", "Drammen", "Tromsø"],
  Poland: ["Warsaw", "Kraków", "Łódź", "Wrocław", "Poznań", "Gdańsk", "Szczecin", "Lublin", "Katowice", "Białystok"],
  Portugal: ["Lisbon", "Porto", "Braga", "Coimbra", "Funchal", "Faro", "Setúbal"],
  Romania: ["Bucharest", "Cluj-Napoca", "Timișoara", "Iași", "Constanța", "Brașov"],
  Serbia: ["Belgrade", "Novi Sad", "Niš", "Kragujevac"],
  Slovakia: ["Bratislava", "Košice", "Prešov", "Nitra", "Žilina", "Banská Bystrica"],
  Slovenia: ["Ljubljana", "Maribor", "Celje", "Kranj", "Koper"],
  Spain: ["Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza", "Málaga", "Bilbao", "Murcia", "Palma", "Alicante"],
  Sweden: ["Stockholm", "Gothenburg", "Malmö", "Uppsala", "Västerås", "Linköping"],
  Switzerland: ["Zürich", "Geneva", "Basel", "Bern", "Lausanne", "Lugano"],
  "United Kingdom": ["London", "Manchester", "Birmingham", "Leeds", "Glasgow", "Edinburgh", "Liverpool", "Bristol", "Cardiff", "Belfast"],
};

export const EUROPE_COUNTRIES = Object.keys(EUROPE);

export const citiesFor = (country) =>
  country && country !== "all" && EUROPE[country] ? EUROPE[country] : [];

// Cities grouped by country — avoids one giant flat list in the pickers.
export const CITY_GROUPS = EUROPE_COUNTRIES.map((c) => ({ country: c, cities: EUROPE[c] }));
